import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/MicroBundle/addNewMicroBundleStyle';
import InfoClause from 'components/infoClause/infoClause';
import { HeadingLBold } from 'components/Typography/Typography';
import { ECommerceService } from 'services/eCommerce/eCommerce';
import idConfig from 'utils/ecommerce/services/id.config';
import { env } from 'config/app.config';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import { PlanCard } from '../commons/Plan';
import { Paginate } from '../commons/Paginate';
import { isMobileDevice } from 'utils/helpers';
import {
	DISPLAY,
	OFFER,
	PLANS_PER_PAGE,
	PLANS_PER_PAGE_MOB,
	WEB_PLAN_INFO,
	discountAttribute,
	downloadSpeedAttribute,
} from '../constants';
import { getLanguage } from 'utils/language/language';
import { useSelector } from 'react-redux';
import { getAamaliPlusLabels } from 'redux/modules/dynamicLabels/selectors';
import Note from 'views/Numbers/Details/Services/subcomponents/common/Note';
import { Star } from '@material-ui/icons';
import { remoteConfigSelector } from 'redux/modules/settings/remoteConfig/selectors';
import { isms365Enabled } from 'utils/killswitch';

interface IMBPlans {
	selectedOption: types.ecommerce.SelectedPlan;
	setSelectedOption: Function;
	index: number;
	setIndex: Function;
}

export const MBPlans = ({ selectedOption, setSelectedOption, index, setIndex }: IMBPlans) => {
	//@ts-ignore
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	const [loading, setLoading] = useState<boolean>(false);
	const [catalog, setCatalog] = useState<types.ecommerce.CatalogEntryView[]>([]);
	const [planDetails, setPlanDetails] = useState<types.ecommerce.PlanDetails[]>([]);
	const [maxPlansPerPage] = useState(isMobileDevice() ? PLANS_PER_PAGE_MOB : PLANS_PER_PAGE);
	const [firstPlanIndex, setfirstPlanIndex] = useState(0);
	const [lastplanIndex, setLastPlanIndex] = useState(maxPlansPerPage);
	const [currentPage, setCurrentPage] = useState(1);
	const maxPages = Math.ceil(catalog.length / maxPlansPerPage);
	const [currentCatalog, setCurrentCatalog] = useState<types.ecommerce.CatalogEntryView[]>([]);
	const language = getLanguage();
	const aamaliPlusLabels = useSelector(getAamaliPlusLabels);
	const remoteConfig = useSelector(remoteConfigSelector);
	const enableMs365 = isms365Enabled(remoteConfig);

	useEffect(() => {
		const currentCatalog = catalog.slice(firstPlanIndex, lastplanIndex);
		setCurrentCatalog(currentCatalog);
	}, [firstPlanIndex, lastplanIndex, catalog, language]);

	useEffect(() => {
		setLoading(true);
		ECommerceService.getGroupContent(idConfig.MICROBUNDLE.PLANS[env]).subscribe(({ response }: any) => {
			setLoading(false);
			setCatalog(response.catalogEntryView);
		});
	}, [language]);

	// plan details that returns price and parsed attributes
	const getPlanDetails = (plan: types.ecommerce.CatalogEntryView) => {
		const priceOb = plan.price?.find((p: any) => p.usage == OFFER);
		const price = priceOb.value;
		const offerPriceOb = plan.price?.find((p: any) => p.usage == DISPLAY);
		const offerPrice = offerPriceOb.value;
		const filteredAttribute = plan.attributes?.filter((attribute: any) => attribute.identifier === WEB_PLAN_INFO);
		const stringifiedAttributes = filteredAttribute?.[0].values[0].value || '{}';
		const parsedAttributes = JSON.parse(stringifiedAttributes);
		return {
			price,
			offerPrice,
			parsedAttributes,
			currency: priceOb.currency,
			uniqueID: plan.uniqueID,
			partNumber: plan.partNumber,
		};
	};

	// Once catalog details is fetched, fetch price details for all plans and set in local state
	useEffect(() => {
		const planPriceDetails: types.ecommerce.PlanDetails[] = [];
		catalog?.map((plan: types.ecommerce.CatalogEntryView) => {
			const { price, parsedAttributes, offerPrice, uniqueID, partNumber } = getPlanDetails(plan) || {};
			planPriceDetails.push({
				name: plan.name,
				price: price,
				offerPrice: offerPrice,
				services: parsedAttributes,
				discount: parsedAttributes[discountAttribute],
				downloadSpeed: parsedAttributes[downloadSpeedAttribute],
				uniqueID: uniqueID,
				partNumber: partNumber,
			});
		});
		setPlanDetails((prev) => {
			return [...planPriceDetails];
		});
	}, [catalog, language]);

	const showPromotionalBanner = selectedOption?.discount?.match(/[1-9]/);
	return (
		<>
			{loading && <CustomCircularProgress loading text="" transparent />}
			<HeadingLBold>{aamaliPlusLabels.choosePlanHeading}</HeadingLBold>
			{!enableMs365 && (
				<div>
					<Note text={aamaliPlusLabels.hold365Banner} removeSpace={true} />
				</div>
			)}
			{selectedOption.name && showPromotionalBanner && aamaliPlusLabels.promotionBanner && (
				// <InfoClause
				// 	message={`${translate('aamali.plus.promotional.price-1', selectedOption.name, selectedOption.price)}`}
				// />
				<InfoClause message={aamaliPlusLabels.promotionBanner} />
			)}
			<div className={classes.plansCardWrapper}>
				{currentCatalog.map((mbPlan: types.ecommerce.CatalogEntryView) => {
					//selectedPlan --> Plan Details can be undefined if uniqueId of current plan does not match with the one in planDetails array.
					const selectedPlan: types.ecommerce.PlanDetails | undefined = planDetails?.find(
						(plan) => plan.uniqueID === mbPlan.uniqueID
					);
					const isDiscountAvailable = selectedPlan?.discount?.match(/[1-9]/);
					if (selectedPlan)
						return (
							<PlanCard
								planDetails={selectedPlan}
								setSelectedOption={setSelectedOption}
								index={index}
								setIndex={setIndex}
								isHovered={selectedOption.uniqueID === selectedPlan.uniqueID}
								onMouseOver={() => {
									setSelectedOption({
										name: selectedPlan.downloadSpeed,
										uniqueID: selectedPlan.uniqueID,
										price: isDiscountAvailable ? selectedPlan?.price : selectedPlan?.offerPrice,
										partNumber: selectedPlan.partNumber,
										displayName: selectedPlan.name,
										discount: selectedPlan.discount,
									});
								}}
							/>
						);
				})}
			</div>
			<br />
			{/* Pagtination will only be displayed when the plans arre more than 3 */}
			{catalog.length > maxPlansPerPage && (
				<div className={classes.paginationWrapper}>
					<Paginate
						currentPage={currentPage}
						setCurrentPage={setCurrentPage}
						maxPages={maxPages}
						lastplanIndex={lastplanIndex}
						setfirstPlanIndex={setfirstPlanIndex}
						setLastPlanIndex={setLastPlanIndex}
						maxItems={catalog.length}
						firstPlanIndex={firstPlanIndex}
					/>
				</div>
			)}
		</>
	);
};
